module.exports = __webpack_public_path__ + "img/image_bg404.9f49a59.png";